export default "/images/phone-call.svg?6a95923bc361c1552d856d03b4c6c44d";